export default "__VITE_ASSET__237f1d0b__"